(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentDeliveryConfirm', {
        templateUrl: 'views/components/views/consignmentDeliveryConfirm/consignmentDeliveryConfirm.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'base64', 'stateService', 'utilityService', 'translateService', 'modalService', 'consignmentDeliveryConfirmService', 'checkListDataService', function ($stateParams, base64, stateService, utilityService, translateService, modalService, consignmentDeliveryConfirmService, checkListDataService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let checkListDataKeyno = $stateParams.checklistdata_keyno;
            let custactNo = $stateParams.custact_no;
            let orderOrderNo = $stateParams.order_order_no;
            let updatingDataFromResponse = false;
            let changeTimer = null;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                custactNo: custactNo,
                info: {},
                setting: {},
                inputListCheckListDatas: {},
                isLockedConfirm: false,
                isLockedConfirmDeviation: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadInfo() {
                vm.model.info = (await consignmentDeliveryConfirmService.getInfo({
                    custact_no: custactNo,
                    order_order_no: orderOrderNo
                }))[0];
            }

            async function loadSetting() {
                vm.model.setting = (await consignmentDeliveryConfirmService.getSetting({ checklistdata_keyno: checkListDataKeyno }))[0];

                if (vm.model.setting.report_html_base64 > '') {
                    vm.model.setting.report_html = base64.urldecode(vm.model.setting.report_html_base64);
                }
            }

            async function loadCheckListDatas() {
                if (utilityService.validateParmsValue(vm.model.info.checklistdata_keyno) !== true) return;

                vm.model.inputListCheckListDatas = (await checkListDataService.listCheckListDatas({ checklistdata_keyno: vm.model.info.checklistdata_keyno }))[0];

                for (let i = 0; i < vm.model.inputListCheckListDatas.checklistitems.length; i++) {
                    validateCheckListData(i);
                }
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region CHANGE FUNCTIONS

            vm.checkListDataOnChange = function (index) {
                if (updatingDataFromResponse) return;

                setTimeout(() => validateCheckListData(index), 50);

                let cldList = vm.model.inputListCheckListDatas.checklistitems;

                if (cldList === undefined || cldList[index] === undefined) return;

                let cldItem = cldList[index];

                if (cldItem.cv === undefined || cldItem.cv !== '1') return;

                let done = false;
                let timerMS = 0;

                switch (cldItem.elementtype) {
                    case 'DT':
                    case 'CL':
                    case 'CB':
                    case 'CS':
                        timerMS = 20;
                        break;
                    default:
                        timerMS = 500;
                }

                if (changeTimer) {
                    done = false;
                    clearTimeout(timerMS);
                }

                async function finishedTyping() {
                    if (done) {
                        let cldConnectedData = [];

                        for (let c = 0; c < cldItem.cvs.length; c++) {
                            for (let d = 0; d < cldList.length; d++) {
                                if (cldItem.cvs[c].clik === cldList[d].checklistitem_keyno) {
                                    cldConnectedData.push({
                                        cii: cldList[d].checklistitem_keyno,
                                        civ: cldList[d].itemvalue
                                    });
                                    break;
                                }
                            }
                        }

                        let updateData = [];

                        checkListDataService.computeValidation({
                            item_id: cldItem.checklistitem_keyno,
                            item_value: cldItem.itemvalue,
                            cvd: cldConnectedData
                        }).then(function (response) {
                            if (response.errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response.errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        }
                                    }]
                                });
                            }

                            if (response.outputresult) {
                                updatingDataFromResponse = true;
                                updateData = response.outputresult;

                                for (let u = 0; u < updateData.length; u++) {
                                    for (let v = 0; v < cldList.length; v++) {
                                        if (updateData[u].clik === cldList[v].checklistitem_keyno && updateData[u].cliv) {
                                            cldList[v].itemvalue = updateData[u].cliv;
                                            validateCheckListData(v);
                                            break;
                                        }
                                    }
                                }

                                updatingDataFromResponse = false;
                            }
                        });

                        return;
                    }

                    done = true;

                    changeTimer = setTimeout(finishedTyping, timerMS);
                }

                finishedTyping();
            }

            async function validateCheckListData(index) {
                if (vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CS' || vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CB' || vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CL') checkDown(index);
            }

            async function checkDown(index) {
                let newItemValue = vm.model.inputListCheckListDatas.checklistitems[index].itemvalue;
                let checkListItemKeyno = vm.model.inputListCheckListDatas.checklistitems[index].checklistitem_keyno;

                for (let i = index + 1; i < vm.model.inputListCheckListDatas.checklistitems.length; i++) {
                    if (vm.model.inputListCheckListDatas.checklistitems[i].dep1_checklistitem_keyno === checkListItemKeyno) {
                        if (vm.model.inputListCheckListDatas.checklistitems[i].dep1_value === newItemValue) {
                            vm.model.inputListCheckListDatas.checklistitems[i].dep1_visible = '1';
                        } else {
                            vm.model.inputListCheckListDatas.checklistitems[i].dep1_visible = '0';
                        }
                    }
                }

                for (let j = index + 1; j < vm.model.inputListCheckListDatas.checklistitems.length; j++) {
                    if (vm.model.inputListCheckListDatas.checklistitems[j].dep2_checklistitem_keyno === checkListItemKeyno) {
                        if (vm.model.inputListCheckListDatas.checklistitems[j].dep2_value === newItemValue) {
                            vm.model.inputListCheckListDatas.checklistitems[j].dep2_visible = '1';
                        } else {
                            vm.model.inputListCheckListDatas.checklistitems[j].dep2_visible = '0';
                        }
                    }
                }
            }

            // #endregion CHANGE FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveAndConfirmChanges = function () {
                vm.model.isLockedConfirm = true;

                consignmentDeliveryConfirmService.saveAndConfirmObj({
                    checklistdata_keyno: vm.model.inputListCheckListDatas.checklistdata_keyno,
                    checklist_keyno: vm.model.inputListCheckListDatas.checklist_keyno,
                    checklist_name: vm.model.inputListCheckListDatas.checklist_name,
                    approve: '0',
                    checklistitems: vm.model.inputListCheckListDatas.checklistitems.map(function (a) {
                        return {
                            "i": a.checklistitemdata_keyno,
                            "v": a.itemvalue
                        };
                    })
                }).then(() => {
                    vm.model.isLockedConfirm = false;

                    consignmentDeliveryConfirmService.getInfo({
                        custact_no: custactNo,
                        order_order_no: orderOrderNo
                    }).then(function () {
                        stateService.go('consignmentdelivery');
                    });
                }, () => vm.model.isLockedConfirm = false);
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON APPROVE PROCEDURE FUNCTION CALL

            vm.saveAndConfirmWithDeviationChanges = function () {
                vm.model.isLockedConfirmDeviation = true;

                consignmentDeliveryConfirmService.saveAndConfirmWithDeviationObj({
                    checklistdata_keyno: vm.model.inputListCheckListDatas.checklistdata_keyno,
                    checklist_keyno: vm.model.inputListCheckListDatas.checklist_keyno,
                    checklist_name: vm.model.inputListCheckListDatas.checklist_name,
                    approve: '1',
                    checklistitems: vm.model.inputListCheckListDatas.checklistitems.map(function (a) {
                        return {
                            "i": a.checklistitemdata_keyno,
                            "v": a.itemvalue
                        };
                    })
                }).then(() => {
                    vm.model.isLockedConfirmDeviation = false;

                    consignmentDeliveryConfirmService.getInfo({
                        custact_no: custactNo,
                        order_order_no: orderOrderNo
                    }).then(function () {
                        stateService.go('consignmentdelivery');
                    });
                }, () => vm.model.isLockedConfirmDeviation = false);
            }

            // #endregion BUTTON APPROVE PROCEDURE FUNCTION CALL

            // #region BUTTON GO BACK FUNCTION

            vm.goBack = function(){
                stateService.back();
            }

            // #endregion BUTTON GO BACK FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadInfo();
                loadSetting();
                loadCheckListDatas();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
